/**
 * Custom event names: `<domain>.<action>` (lowercase, dot-separated).
 * The `addin.` prefix is applied once in `useAppInsights` — do not embed it here.
 */
export const TelemetryEvents = {
  appLaunched: "app.launched",
  pageChanged: "page.changed",
  userLoggedIn: "user.logged_in",
  userLoggedInFailed: "user.logged_in_failed",
  userLoggedInWithoutOrganisation: "user.logged_in_without_organisation",
  userLoggedInDeactivatedOrganisation: "user.logged_in_deactivated_organisation",
  /** Receivables / suggested chasables list filters */
  receivableFilterUsed: "receivable.filter_used",

  receivableChaseSucceeded: "receivable.chase_succeeded",
  receivableChaseFailed: "receivable.chase_failed",
  receivableCompleteSucceeded: "receivable.complete_succeeded",
  receivableCompleteFailed: "receivable.complete_failed",
  receivableSkipApplied: "receivable.skip_applied",
  receivableSkipFailed: "receivable.skip_failed",

  searchQuerySubmitted: "search.query_submitted",
  searchResultSelected: "search.result_selected",
  payableSearchQuerySubmitted: "payable.search_query_submitted",
  payableSearchResultSelected: "payable.search_result_selected",

  emailAssignSucceeded: "email.assign_succeeded",
  emailAssignFailed: "email.assign_failed",

  activityCommentSubmitted: "activity.comment_submitted",
  activityCommentFailed: "activity.comment_failed",

  navigationDashboardEntryClicked: "navigation.dashboard_entry_clicked",
  navigationReceivablesHubAction: "navigation.receivables_hub_action",
  payableSupplierListViewed: "payable.supplier_list_viewed",
  payableInvoiceRowOpened: "payable.invoice_row_opened",
  receivableGroupedChaseViewed: "receivable.grouped_chase_viewed",
  receivableToneAdjusted: "receivable.tone_adjusted",
  receivableOrganisationAttachmentAdded: "receivable.organisation_attachment_added",
} as const;

export type TelemetryEventName = (typeof TelemetryEvents)[keyof typeof TelemetryEvents];
